import { Component, Vue } from 'vue-property-decorator';
import { SelectOption } from '@/types/types';

// gql
import fetchCustomerOrganizationsQuery from '@/graphql/queries/FetchCustomerOrganizations.gql';

import { CustomerOrganizationFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    customerOrganizationOptions: {
      query: fetchCustomerOrganizationsQuery,
      debounce: 300,
      prefetch: true,
      variables() {
        return {
          customerOrganizationArgs: {
            name: this.searchCustomerOrganization || null
          },
          pagination: { page: 1, per: 25 }
        };
      },
      update(data): SelectOption<string>[] {
        if (data.customerOrganizations) {
          return data.customerOrganizations.map((customer: CustomerOrganizationFields) => {
            return {
              label: customer.name,
              value: customer
            };
          });
        }
        return [];
      }
    }
  }
})

export default class CustomerOrganizationOptionsMixin extends Vue {
  public customerOrganizationOptions: SelectOption<string>[] = [];
  public searchCustomerOrganization = '';
}
